export function throttle (callback, delay) {
  let timeoutHandler = null
  return function () {
    if (timeoutHandler == null) {
      timeoutHandler = setTimeout(function () {
        callback()
        clearInterval(timeoutHandler)
        timeoutHandler = null
      }, delay)
    }
  }
}

export function debounce (callback, delay) {
  let timeoutHandler = null
  return function () {
    clearTimeout(timeoutHandler)
    timeoutHandler = setTimeout(function () {
      callback()
    }, delay)
  }
}
